import { BudgetTypeModel } from '@/features/master-table/models';
import { z } from 'zod';
import { ExecutionItemModel } from './execution-item';
import { ExpenditureItemBaseModel } from './expenditure-item';

/// //////////////////////////////////////////////////
/// Model
/// /////////////////////////////////////////////////

export const ConsecutiveBudgetsModel = ExpenditureItemBaseModel.pick({
  id: true,
  budgetTypeId: true,
})
  .extend({
    name: z.string().min(1),
    budgetType: BudgetTypeModel.shape.type,
    budgetTypeName: z.string().min(1).nullable(),
    fiscalYear: z.number().int(),
    finalizedAmount: ExpenditureItemBaseModel.shape.finalizedAmount.nullable(),
    requestedAmount: ExpenditureItemBaseModel.shape.requestedAmount.nullable(),
    negativeFinalizedAmountCount: z.number().nullish(),
    negativeRequestedAmountCount: z.number().nullish(),
  })
  .array();

export const ConsecutiveExecutionsModel = ExecutionItemModel.pick({
  id: true,
  name: true,
})
  .extend({
    fiscalYear: z.number().int(),
    amount: ExecutionItemModel.shape.amount.nullable(),
    negativeAmountCount: z.number().nullish(),
  })
  .array();
